import { render, staticRenderFns } from "./ChangeShiftTable.vue?vue&type=template&id=519195c0"
import script from "./ChangeShiftTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeShiftTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports